import React, { useState } from "react";
// import Navbar from '../navbar/Navbar';

import { Outlet } from "react-router-dom";
// import AdminHome from '../pages/AdminPannel/dashboard/Dashboard';
// import AdminHome from '../home/AdminHome';
import TopBar from "../navbar/TopNav";
import AccountNav from "../navbar/AccountNav";
import NavigationBar from "../navbar/Navbar";
import Footer from "../pages/Frontend/homePage/components/footer/Footer";
function MyAccountLayout() {
  return (
    <>
      <NavigationBar className="w-screen " />
      <div className="flex lg:mt-[76px] bg-gradient-to-b from-[#fbfbfb] to-[#f7f7f7] mt-[50px]">
        <AccountNav className="w-1/4" />
        <div className="w-full p-3 mx-auto">
          <Outlet />
        </div>
      </div>
      <Footer />
    </>
  );
}
export default MyAccountLayout;
